import React from "react";
import ModalImage from "react-modal-image";
import "./index.css";
import { siteContent } from "../content";

const images = siteContent.gallery.images;

const Galeria = () => {
    return (
        <div className="section galeria">
            <div className="container-lg flex flexCol flexCenter">
                <h5 className="textCenter">{siteContent.gallery.eyebrow}</h5>
                <h2 className="textCenter titleSec">{siteContent.gallery.title}</h2>
                <div className="imagenes">
                    {images.map((image, index) => (
                        <div key={index} className="imagenItem">
                            <ModalImage
                                hideDownload={true}
                                small={image.src}
                                large={image.src}
                                alt={image.description}
                                className="imagen"
                                imageBackgroundColor="#ffffff"
                            />
                            <p className="descripcion">{image.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Galeria;
